import { Uuid } from "@m7-health/shared-utils";

import { useAppConfigQuery } from "#/features/User/queries";

import { IncentiveLevelDropdown as IncentiveLevelDropdownComponent } from "../../ShiftIncentiveLevel";
import { useEnsureMatchingUnitIncentiveLevel } from "../helpers";
import { TShiftEditorProps } from "../types";

export const IncentiveLevelPicker = (props: TShiftEditorProps) => {
  const { staffShift, updateStaffShift, unitOfShift } = props;
  const allAvailableUnits = useAppConfigQuery().data?.accessibleUnits;

  useEnsureMatchingUnitIncentiveLevel({
    staffShift,
    unitOfShift,
    allAvailableUnits,
    updateStaffShift,
  });

  return (
    <IncentiveLevelDropdownComponent
      size="small"
      unitId={unitOfShift.id}
      value={staffShift.incentiveLevelId || ""}
      onChange={(event) => {
        const incentiveLevelId = (event.target.value || null) as Uuid | null;
        updateStaffShift({ ...staffShift, incentiveLevelId });
      }}
    />
  );
};
